import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { userDataActions } from "reducers/userDataReducer";

// routes
import AppRoutes from "routes/AppRoutes";

// cover
import { Container } from "semantic-ui-react";

// socket
import SocketContext from "contexts/SocketContext";

function App() {
	const dispatch = useDispatch();

	useEffect(() => {
		const localUserData = JSON.parse(localStorage.getItem("user"));
		if (
			localUserData &&
			localUserData.tokens &&
			localUserData.tokens.accessToken
		) {
			dispatch(
				userDataActions.addToken(localUserData.tokens.accessToken)
			);
		}
	}, [dispatch]);

	return (
		<SocketContext>
			<Container style={{ minHeight: "100vh" }} fluid className="App">
				<AppRoutes />
			</Container>
		</SocketContext>
	);
}

export default App;
